(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-wijncom"] && !Shopify.designMode) return;
  try {
    
  /* Open/gesloten-stip bij de openingstijden. Leest de tijden uit de tabelrijen
     (data-dagen "0-4" = maandag t/m vrijdag, data-uren "09:00 - 18:00" of "Gesloten")
     en rekent in Nederlandse tijd, zodat de stip klopt voor bezoekers in elke tijdzone. */
  (function () {
    var status = document.querySelector('[data-ft-status]');
    if (!status) return;

    var rijen = document.querySelectorAll('.ft__uren tr[data-dagen]');
    var delen = new Intl.DateTimeFormat('nl-NL', {
      timeZone: 'Europe/Amsterdam', weekday: 'short', hour: 'numeric', minute: 'numeric', hour12: false
    }).formatToParts(new Date());
    var deel = {};
    delen.forEach(function (d) { deel[d.type] = d.value; });

    var dagIndex = ['ma', 'di', 'wo', 'do', 'vr', 'za', 'zo'].indexOf(deel.weekday.replace('.', ''));
    var nu = parseInt(deel.hour, 10) * 60 + parseInt(deel.minute, 10);
    var uren = null;

    rijen.forEach(function (rij) {
      var bereik = rij.getAttribute('data-dagen').split('-').map(Number);
      if (dagIndex >= bereik[0] && dagIndex <= bereik[1]) uren = rij.getAttribute('data-uren');
    });

    var tijd = uren && uren.match(/(\d{1,2}):(\d{2})\D+(\d{1,2}):(\d{2})/);
    var tekst;
    var open = false;

    if (tijd) {
      var van = parseInt(tijd[1], 10) * 60 + parseInt(tijd[2], 10);
      var tot = parseInt(tijd[3], 10) * 60 + parseInt(tijd[4], 10);
      open = nu >= van && nu < tot;
      if (open) tekst = 'Nu open, tot ' + tijd[3] + ':' + tijd[4] + ' uur';
      else if (nu < van) tekst = 'Nu gesloten, vandaag open vanaf ' + tijd[1] + ':' + tijd[2] + ' uur';
      else tekst = 'Nu gesloten';
    } else {
      tekst = 'Vandaag gesloten';
    }

    status.classList.toggle('ft__status--open', open);
    status.querySelector('[data-ft-status-tekst]').textContent = tekst;
    status.hidden = false;
  })();

  /* Google Maps plaatst cookies van Google. De kaart laadt daarom pas na toestemming
     voor marketingcookies (Shopify Customer Privacy API), of als de bezoeker zelf op
     "Kaart tonen" klikt. */
  document.querySelectorAll('[data-ft-kaart]').forEach(function (kaart) {
    var frame = kaart.querySelector('iframe[data-src]');
    var knop = kaart.querySelector('[data-ft-kaart-toon]');
    if (!frame) return;

    function toon() {
      if (!frame.getAttribute('src')) frame.setAttribute('src', frame.getAttribute('data-src'));
      frame.hidden = false;
      kaart.classList.add('ft__kaart--aan');
    }

    function check() {
      var privacy = window.Shopify && window.Shopify.customerPrivacy;
      if (privacy && typeof privacy.marketingAllowed === 'function' && privacy.marketingAllowed()) toon();
    }

    if (knop) knop.addEventListener('click', toon);
    document.addEventListener('visitorConsentCollected', function (event) {
      if (event.detail && event.detail.marketingAllowed) toon();
    });

    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (fout) {
        if (!fout) check();
      });
    } else {
      check();
    }
  });

  /* Cookievoorkeuren: opent het voorkeurenvenster van de Shopify-cookiebanner
     (Customer Privacy API). Is dat script er niet, dan volgt de link gewoon
     zijn adres (het privacybeleid). */
  document.querySelectorAll('[data-ft-cookies]').forEach(function (link) {
    link.addEventListener('click', function (event) {
      if (window.privacyBanner && typeof window.privacyBanner.showPreferences === 'function') {
        event.preventDefault();
        window.privacyBanner.showPreferences();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  if (!customElements.get('grid-banner-vuller')) {
    /**
     * Zet in een onvolle laatste rij van de productgrid één bannertegel. De opvultegel
     * staat verborgen na het laatste product; dit element telt de kolommen van de grid
     * zoals die nu getekend is. Is de laatste rij niet vol, dan komt de tegel zichtbaar
     * vóór het laatste product te staan: nooit meer dan één opvulbanner en nooit een
     * banner als laatste tegel (keuze baas 27-9). Staat de rij al vol (of is er maar
     * één kolom, zoals op mobiel), dan blijft hij verborgen.
     */
    class GridBannerVuller extends HTMLElement {
      #resize = null;
      #children = null;
      #timer = 0;

      connectedCallback() {
        const grid = this.#grid;
        if (!grid) return;
        this.#resize = new ResizeObserver(() => this.#plan());
        this.#resize.observe(grid);
        // Filteren en sorteren tekenen de grid opnieuw; alleen op nieuwe of verdwenen
        // kaarten letten, niet op attributen, anders houdt dit zichzelf aan de gang.
        this.#children = new MutationObserver(() => this.#plan());
        this.#children.observe(grid, { childList: true });
        this.#plan();
      }

      disconnectedCallback() {
        this.#resize?.disconnect();
        this.#children?.disconnect();
        clearTimeout(this.#timer);
      }

      get #grid() {
        return this.closest('li')?.parentElement ?? null;
      }

      /** Bundelt meldingen van de observers; met een timer, zodat het ook werkt in een
       *  tabblad dat (nog) op de achtergrond staat. */
      #plan() {
        clearTimeout(this.#timer);
        this.#timer = setTimeout(() => this.#update(), 0);
      }

      #update() {
        const grid = this.#grid;
        if (!grid) return;
        const cells = Array.from(grid.children).filter((el) => el.tagName === 'LI');
        const vullers = cells.filter((el) => el.classList.contains('product-grid__item--banner-vul'));
        // Hooguit één opvulbanner: staan er meer (meerdere pagina's), dan telt alleen de laatste.
        const vuller = vullers.at(-1);
        vullers.forEach((cel) => {
          if (cel !== vuller && !cel.hidden) cel.hidden = true;
        });
        if (!vuller) return;

        const zichtbaar = (el) => !el.hidden && el.offsetParent !== null;
        const bezet = cells.filter(
          (el) => !el.classList.contains('product-grid__item--banner-vul') && zichtbaar(el)
        ).length;
        const laatste = cells.filter((el) => el.dataset.productId && zichtbaar(el)).at(-1);
        const kolommen = getComputedStyle(grid).gridTemplateColumns.split(' ').filter(Boolean).length || 1;
        // Een tegel zonder banner (de rotator had er geen meer over) blijft weg.
        const heeftBanner = vuller.querySelector(
          'grid-banner-rotator > :not(.grid-banner-rotator__banner--hidden):not(.grid-banner-rotator__hint)'
        );
        const tonen = kolommen > 1 && bezet % kolommen !== 0 && Boolean(laatste) && Boolean(heeftBanner);

        if (tonen && vuller.nextElementSibling !== laatste) grid.insertBefore(vuller, laatste);
        if (vuller.hidden === tonen) vuller.hidden = !tonen;
      }
    }

    customElements.define('grid-banner-vuller', GridBannerVuller);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-manufacturers"] && !Shopify.designMode) return;
  try {
    
class ManufacturerOverview extends HTMLElement {
  connectedCallback() {
    this.body = this.querySelector('[data-manufacturers-body]');
    this.loading = this.querySelector('.main-manufacturers__loading');
    if (!this.body) return;

    // Delegated smooth-scroll so it survives a rebuild of the body.
    this.addEventListener('click', this.onNavClick.bind(this));

    this.hydrate();
  }

  get totalPages() {
    return parseInt(this.dataset.totalPages, 10) || 1;
  }

  async hydrate() {
    // Rows rendered server-side for the first paginated page.
    let rows = Array.from(this.querySelectorAll('.main-manufacturers__table-row'));

    if (this.totalPages > 1) {
      if (this.loading) this.loading.hidden = false;
      const fetched = await this.fetchRemainingRows();
      rows = rows.concat(fetched);
      if (this.loading) this.loading.hidden = true;
    }

    // Only rebuild when there is something extra to merge; otherwise the
    // server render is already complete and correctly ordered enough.
    if (this.totalPages > 1) {
      this.render(rows);
      // Alles staat er nu: de onzichtbare paginalinks zijn niet meer nodig.
      this.querySelector('[data-manufacturers-pages]')?.remove();
    }
  }

  async fetchRemainingRows() {
    const sectionId = this.dataset.sectionId;
    const pageParam = this.dataset.paginateParam || 'page';
    const requests = [];
    // Alle andere pagina's ophalen, ook pagina 1 als de bezoeker op pagina 2 binnenkomt.
    const currentPage = parseInt(this.dataset.currentPage, 10) || 1;
    for (let page = 1; page <= this.totalPages; page++) {
      if (page === currentPage) continue;
      const url = `${window.location.pathname}?section_id=${encodeURIComponent(sectionId)}&${encodeURIComponent(pageParam)}=${page}`;
      requests.push(
        fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
          .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
          .then((html) => {
            const doc = new DOMParser().parseFromString(html, 'text/html');
            return Array.from(doc.querySelectorAll('.main-manufacturers__table-row')).map((node) =>
              document.importNode(node, true)
            );
          })
          .catch(() => [])
      );
    }
    const pages = await Promise.all(requests);
    return pages.flat();
  }

  render(rows) {
    // Dedupe by manufacturer handle, then group by country.
    const seen = new Set();
    const groups = new Map(); // handle -> { name, rows: [] }

    for (const row of rows) {
      const handle = row.dataset.handle;
      if (handle && seen.has(handle)) continue;
      if (handle) seen.add(handle);

      const countryHandle = row.dataset.countryHandle;
      if (!countryHandle) continue;
      if (!groups.has(countryHandle)) {
        groups.set(countryHandle, { name: row.dataset.countryName || '', rows: [] });
      }
      groups.get(countryHandle).rows.push(row);
    }

    const collator = new Intl.Collator('nl', { sensitivity: 'base' });
    const sortedCountries = Array.from(groups.entries()).sort((a, b) =>
      collator.compare(a[1].name, b[1].name)
    );

    // Reuse the server-rendered <nav> and content wrappers so their layout
    // classes are preserved; only swap the inner items.
    if (this.showNavCount === undefined) {
      this.showNavCount = !!this.querySelector('.main-manufacturers__nav-count');
    }
    const navList = this.querySelector('.main-manufacturers__nav-list');
    if (navList) {
      navList.replaceChildren(
        ...sortedCountries.map(([handle, group]) => this.buildNavItem(handle, group))
      );
    }

    const content = this.querySelector('.main-manufacturers__content');
    if (content) {
      content.replaceChildren(
        ...sortedCountries.map(([handle, group]) => {
          group.rows.sort((a, b) => collator.compare(a.dataset.name || '', b.dataset.name || ''));
          return this.buildCountrySection(handle, group);
        })
      );
    }
  }

  buildNavItem(handle, group) {
    const li = document.createElement('li');
    li.className = 'main-manufacturers__nav-item';
    const a = document.createElement('a');
    a.className = this.dataset.navLinkClass || 'main-manufacturers__nav-button';
    if (this.dataset.navLinkStyle) a.setAttribute('style', this.dataset.navLinkStyle);
    a.href = `#country-${handle}`;
    a.textContent = group.name;
    if (this.showNavCount) {
      const n = document.createElement('span');
      n.className = 'main-manufacturers__nav-count';
      n.textContent = group.rows.length;
      a.appendChild(n);
    }
    li.appendChild(a);
    return li;
  }

  countLabel(n) {
    const tpl = n === 1 ? this.dataset.i18nCountOne : this.dataset.i18nCountMany;
    return (tpl || '[n]').replace('[n]', n);
  }

  buildCountrySection(handle, group) {
    const section = document.createElement('section');
    section.id = `country-${handle}`;
    section.className = 'main-manufacturers__country-section';
    section.setAttribute('aria-labelledby', `country-heading-${handle}`);

    // Gekleurd landenblok: naam, aantal, streken
    const block = document.createElement('div');
    block.className = 'main-manufacturers__country-block';
    const top = document.createElement('div');
    const heading = document.createElement('h2');
    heading.id = `country-heading-${handle}`;
    heading.className = 'main-manufacturers__country-heading';
    heading.textContent = group.name;
    top.appendChild(heading);
    const count = document.createElement('p');
    count.className = 'main-manufacturers__country-count';
    count.textContent = this.countLabel(group.rows.length);
    top.appendChild(count);
    block.appendChild(top);

    const maxRegions = parseInt(this.dataset.maxRegions, 10) || 0;
    const regions = [];
    for (const row of group.rows) {
      const r = row.dataset.region;
      if (r && !regions.includes(r)) regions.push(r);
    }
    if (maxRegions > 0 && regions.length) {
      const collator = new Intl.Collator('nl', { sensitivity: 'base' });
      regions.sort(collator.compare);
      const ul = document.createElement('ul');
      ul.className = 'main-manufacturers__regions';
      ul.setAttribute('role', 'list');
      for (const r of regions.slice(0, maxRegions)) {
        const li = document.createElement('li');
        li.textContent = r;
        ul.appendChild(li);
      }
      if (regions.length > maxRegions) {
        const li = document.createElement('li');
        li.textContent = `+${regions.length - maxRegions}`;
        ul.appendChild(li);
      }
      block.appendChild(ul);
    }
    section.appendChild(block);

    const table = document.createElement('div');
    table.className = 'main-manufacturers__table';
    table.setAttribute('role', 'list');
    table.setAttribute(
      'aria-label',
      (this.dataset.i18nTableLabel || '').replace('%%COUNTRY%%', group.name)
    );
    for (const row of group.rows) table.appendChild(row);
    section.appendChild(table);
    return section;
  }

  onNavClick(event) {
    const link = event.target.closest('.main-manufacturers__nav-button');
    if (!link || !this.contains(link)) return;

    const targetId = link.getAttribute('href');
    const target = targetId && this.querySelector(targetId);
    if (!target) return;

    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    history.pushState(null, '', targetId);

    const heading = target.querySelector('.main-manufacturers__country-heading');
    if (heading) {
      heading.setAttribute('tabindex', '-1');
      heading.focus();
    }
  }
}

if (!customElements.get('manufacturer-overview')) {
  customElements.define('manufacturer-overview', ManufacturerOverview);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["palmares-carousel"] && !Shopify.designMode) return;
  try {
    
  // Center items when count is less than or equal to columns
  document.addEventListener('DOMContentLoaded', () => {
    const wrapper = document.querySelector('.palmares-carousel__wrapper');
    if (!wrapper) return;

    const itemCount = parseInt(getComputedStyle(wrapper).getPropertyValue('--palmares-item-count'));
    const columns = parseInt(getComputedStyle(wrapper).getPropertyValue('--palmares-columns'));

    if (itemCount <= columns) {
      wrapper.style.setProperty('--palmares-justify', 'center');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-viewer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('change', (event) => {
    if (!event.target.classList.contains('video-viewer__radio')) return;
    const viewer = event.target.closest('.video-viewer');
    if (!viewer) return;
    viewer.querySelectorAll('video').forEach((video) => video.pause());
    // Voorbeeldbeeld van de gekozen video pas nu zetten (data-poster, 29-9-2026).
    const radios = [...viewer.querySelectorAll('.video-viewer__radio')];
    const item = viewer.querySelectorAll('.video-viewer__item')[radios.indexOf(event.target)];
    const gekozen = item?.querySelector('video[data-poster]');
    if (gekozen && !gekozen.getAttribute('poster')) gekozen.setAttribute('poster', gekozen.dataset.poster);
  });

  // Links naar #video-viewer (bijv. de TV-banner op de homepage): smooth
  // scrollen naar de sectie en de zichtbare (aangevinkte) video afspelen.
  // play() mag met geluid omdat dit binnen de klik (user gesture) gebeurt.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('a[href$="#video-viewer"]');
    if (!trigger) return;
    const sectionEl = document.getElementById('video-viewer');
    if (!sectionEl) return;

    event.preventDefault();
    sectionEl.scrollIntoView({ behavior: 'smooth', block: 'start' });

    const radios = [...sectionEl.querySelectorAll('.video-viewer__radio')];
    const items = [...sectionEl.querySelectorAll('.video-viewer__item')];
    const index = Math.max(0, radios.findIndex((radio) => radio.checked));
    const video = items[index]?.querySelector('video');
    if (video && video.dataset.poster && !video.getAttribute('poster')) video.setAttribute('poster', video.dataset.poster);
    if (video) {
      sectionEl.querySelectorAll('video').forEach((other) => {
        if (other !== video) other.pause();
      });
      video.play();
    }
  });

  } catch(e) { console.error(e); }
})();
})();
